// @flow
import BaseComponent from '../base_component/base_component';
import {deferrablePost} from '../../assets/javascripts/offline_handler';

export default class AvailableProducts extends BaseComponent {
    functions() {
        return {
            addSearch: (term: string) => this.filterBy(term),
            removeSearch: () => this.find('.product').show()
        }
    }

    filterBy(term: string) {
        this.find('.product').each((i, product) => {
            if ($(product).data('name').includes(term)) return;

            $(product).hide();
        })
    }

    request() {
        let requestedProducts = this.find('input[type="checkbox"][data-type="product"]:checked')
            .map((i, e) => `${$(e).data('name')}`).get();
        let headers: any = { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') };
        if (requestedProducts.length == 0) return;

        let paramsData = {products: requestedProducts}
        this.find('.title').hide();
        this.find('.fa-spinner').show();
        deferrablePost('/request_products', paramsData, headers).then(deferred => {
            this.find('.fa-spinner').hide();
            this.find('.title').show();
            this.find('.success-overlay').show();
            this.find(`.request-sent-${deferred ? 'off' : 'on'}line`).show();
            this.find(`.request-sent-${deferred ? 'on' : 'off'}line`).hide();
        })
    }

    hide() {
        this.find('.success-overlay').hide();
    }
}